import {
  TextInput,
  Grid,
  Stack,
  ScrollArea,
  Button,
  Select,
  LoadingOverlay,
} from "@mantine/core";
import React from "react";
import { useMutation } from "@apollo/client";
import { showNotification } from "@mantine/notifications";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { CHANGE_STATUS } from "apollo/mutuations";

import { customLoader } from "components/utilities/loader";

const ChangeStatusAddModal = ({ id, setOpened }) => {
  const form = useForm({
    initialValues: {
      status: "PENDING",
    },
  });

  const [changeProductReturnStatus, { loading, error }] =
    useMutation(CHANGE_STATUS);

  const { height } = useViewportSize();
  const submit = () => {
    changeProductReturnStatus({
      variables: {
        id: id,
        status: form.getInputProps("status").value,
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Status Updated Successfully",
        });
        setOpened(false);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message ||
            "Status not Updated Successfully",
        });
      },
    });
  };
  const handleCategoryChange = (val) => {
    form.setFieldValue("status", val || []);
  };
  return (
    <>
      <LoadingOverlay
        visible={loading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={6}>
                <Select
                  searchable
                  required
                  clearable
                  data={[
                    { value: "PENDING", label: "Pending" },
                    { value: "REJECTED", label: "Rejected" },
                    { value: "RESOLVED", label: "Resolved" },
                    { value: "PAID", label: "Paid" },
                  ]}
                  value={form.values.status}
                  onChange={handleCategoryChange}
                  label="Status"
                />
              </Grid.Col>
              <Grid.Col span={6}>
                <Button
                  style={{
                    width: "40%",
                    marginTop: "23px",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  fullWidth
                  type="submit"
                  color="blue"
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};

export default ChangeStatusAddModal;
